import React from 'react'
import { useTranslation } from 'react-i18next'
import { HiShieldCheck } from 'react-icons/hi'
import { formatDate } from '../../../utils/FormateDateTime'

const ReferralEligibilitySummary = ({
  authRef,
  validUntil,
  isEligible = true,
  rightAction = null
}) => {
  const { t } = useTranslation()

  if (!authRef || !validUntil) return null

  return (
    <div
      className={`mb-3 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 rounded-md border px-3 py-2 text-gray-700 ${
        isEligible
          ? 'border-green-200 bg-green-50'
          : 'border-yellow-200 bg-yellow-50'
      }`}
    >
      <div className='flex flex-wrap items-center gap-x-6 gap-y-1'>
        <div
          className={`flex items-center gap-1.5 font-semibold text-[12px] ${
            isEligible ? 'text-green-700' : 'text-yellow-700'
          }`}
        >
          <HiShieldCheck size={17} />
          {isEligible
            ? t('Eligible through referral')
            : t('Referral eligibility override available')}
        </div>
        <div className='text-[12px]'>
          <span className='font-semibold '>
            {t('Authorization Reference')}:
          </span>{' '}
          {authRef}
        </div>
        <div className='text-[12px]'>
          <span className='font-semibold'>{t('Valid Until')}:</span>{' '}
          {formatDate(validUntil, 'DD/MM/YYYY')}
        </div>
      </div>
      {rightAction && <div className='shrink-0'>{rightAction}</div>}
    </div>
  )
}

export default ReferralEligibilitySummary
